export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /builds/angulartutor/angulartutor.gitlab.io/src/environments/environment.ts